import { EasyTradeInquiryModel } from 'src/models/request/EasyTradeInquity.model';
import DataLayerHelper from 'src/utils/setDataLayer';
import apiUrl from '../config/apiUrl';
import fetchUrl from '../utils/fetchUrl';

export const EASY_TRADE_REGISTER = async (preOrderId: string) => {
  const url = `${apiUrl}order/easy-trade/register?trackId=${preOrderId}`;
  return await fetchUrl({
    url: url,
    method: 'POST',
  });
};
export const EASY_TRADE_INQUIRY_BUY = async (data: EasyTradeInquiryModel) => {
  const url = `${apiUrl}order/easy-trade/inquiry/buy`;

  DataLayerHelper('buy otc', {
    coinbuyotc: data.currency,
    valuebuyotc: data.amount,
  });
  return await fetchUrl({
    url: url,
    method: 'POST',
    body: data,
  });
};
export const EASY_TRADE_INQUIRY_SELL = async (data: EasyTradeInquiryModel) => {
  const url = `${apiUrl}order/easy-trade/inquiry/sell`;
  DataLayerHelper('sell otc', {
    coinsellotc: data.currency,
    valuesellotc: data.amount,
  });
  return await fetchUrl({
    url: url,
    method: 'POST',
    body: data,
  });
};
export const EASY_TRADE_PRICE_INQUIRY = async (
  mode: string,
  currency: string,
) => {
  const url = `${apiUrl}order/easy-trade/price/${mode}?currency=${currency}`;
  return await fetchUrl({
    url: url,
    method: 'GET',
  });
};
export const GET_TRADE_WAGE = async (
  coin: string, 
  orderSide: string,
) => {
  const url = `${apiUrl}order/wage/coin?coin=${coin}&orderSide=${orderSide}`;
  return await fetchUrl({
    url: url,
    method: 'GET',
  });
};
export const GET_WALLET_LIMIT = async () => {
  const url = `${apiUrl}order/walletLimit`;
  return await fetchUrl({
    url: url,
    method: 'GET',
  });
};
